import { render, staticRenderFns } from "./RedeemOfferItemProperty.vue?vue&type=template&id=6c225f91&scoped=true&lang=pug&"
import script from "./RedeemOfferItemProperty.vue?vue&type=script&lang=js&"
export * from "./RedeemOfferItemProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c225f91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow,VSpacer})
